import React from 'react';
import { Box, Grid, Card, CardContent, Typography, Avatar } from '@mui/material';

// Helper function to format the date
const formatDate = (year, month, day) => `${year}-${month}-${day}`;

// ProfileCard Component
const ProfileCard = ({ profileData }) => {
  // Map different possible key names to consistent ones
  const {
    ABHANumber,
    healthIdNumber,
    preferredAbhaAddress,
    healthId,
    firstName,
    lastName,
    name,
    yearOfBirth,
    monthOfBirth,
    dayOfBirth,
    profilePhoto,
    gender,
  } = profileData;

  // Normalize the values to be used in the UI
  const normalizedName = name || `${firstName} ${lastName}` || '';
  const normalizedHealthIdNumber = healthIdNumber || ABHANumber || '-';
  const normalizedHealthId = healthId || preferredAbhaAddress || '-';
  const profilePhotoSrc = `data:image/jpeg;base64,${profilePhoto}`;
  const normalizedGender = gender === 'F' ? 'Female' : gender === 'M' ? 'Male' : '-';

  return (
    <Box>
      {/* Adding a heading */}
      <Typography
        variant="h6"
        style={{ marginBottom: '20px', textAlign: 'center' }}
      >
        ABHA Profile
      </Typography>

      <Card
        style={{
          maxWidth: 500,
          margin: '0 auto',
          marginBottom: '20px',
          paddingTop: '20px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
        }}
      >
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Avatar
                alt={normalizedName}
                src={profilePhotoSrc}
                style={{ width: 80, height: 80 }}
              />
            </Grid>
            <Grid item xs>
              <Typography variant="h6">{normalizedName}</Typography>
              <Typography variant="subtitle1">{`ABHA Number: ${normalizedHealthIdNumber}`}</Typography>
              <Typography variant="subtitle1">{`ABHA Address: ${normalizedHealthId}`}</Typography>
              <Typography variant="subtitle1">{`Gender: ${normalizedGender}`}</Typography>
              <Typography variant="subtitle1">{`DOB: ${formatDate(yearOfBirth, monthOfBirth, dayOfBirth)}`}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProfileCard;
